import { API_BASE_URL } from "../../../config/environment";

class FirebaseStorageManager {
    static getAuthToken() {
        return document.cookie
            .split("; ")
            .find((cookie) => cookie.startsWith("authToken="))
            ?.slice("authToken=".length);
    }

    static async uploadFile(file, path, filename) {
        const authToken = this.getAuthToken();
        if (!authToken) {
            throw new Error("Administrator authentication is required.");
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("path", path);
        formData.append("filename", filename);

        const response = await fetch(`${API_BASE_URL}/admin/uploads`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${authToken}`,
                Accept: "application/json",
            },
            credentials: "include",
            body: formData,
        });

        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
            throw new Error(payload.reason || payload.message || "File upload failed.");
        }
        if (!payload.url) {
            throw new Error("The upload response did not contain a file URL.");
        }

        return payload.url;
    }
}

export default FirebaseStorageManager;
